import { countryService, departmentService, cityService } from "@/services";
import { useEffect, useState } from "react";

type Option = { label: string; value: string };

export function useLocations(paisId?: string, departamentoId?: string) {
  const [paises, setPaises] = useState<Option[]>([]);
  const [departamentos, setDepartamentos] = useState<Option[]>([]);
  const [ciudades, setCiudades] = useState<Option[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchPaises = async () => {
      setLoading(true);
      try {
        const data = await countryService.getAll();
        setPaises(data.map((x: any) => ({ label: x.nombre, value: x.id })));
      } finally {
        setLoading(false);
      }
    };
    fetchPaises();
  }, []);

  // 2. Cargar departamentos cuando cambie paisId
  useEffect(() => {
    const fetchDepartamentos = async () => {
      if (!paisId) {
        setDepartamentos([]);
        setCiudades([]); // reset ciudades también
        return;
      }
      setLoading(true);
      try {
        const data = await departmentService.getDepartmentsByCountry(paisId);
        setDepartamentos(
          data.map((x: any) => ({ label: x.nombre, value: x.id }))
        );
      } finally {
        setLoading(false);
      }
    };

    if (paisId) fetchDepartamentos();
  }, [paisId]);

  useEffect(() => {
    const fetchCiudades = async () => {
      if (!departamentoId) {
        setCiudades([]);
        return;
      }
      setLoading(true);
      try {
        const data = await cityService.getByCitiesDepartments(departamentoId);
        setCiudades(data.map((x: any) => ({ label: x.nombre, value: x.id })));
      } finally {
        setLoading(false);
      }
    };

    if (departamentoId) fetchCiudades();
  }, [departamentoId]);

  return {
    paises,
    departamentos,
    ciudades,
    loading,
  };
}
